import React, { useEffect, useLayoutEffect } from 'react'
import { MediaQueryProvider } from './src/hooks/useMediaQuery'
import { LocationProvider } from './src/hooks/useLocation'
import { AmplitudeProvider } from './src/AmplitudeProvider'
import { AmplitudeExperimentProvider } from './src/AmplitudeExperimentProvider'
import { AmplitudeEngagementProvider } from './src/engagement/AmplitudeEngagementProvider'
import SanityProvider from './src/context/SanityContext'

const INITIAL_AMPLITUDE_LOADING_SCREEN_ID = 'initial-amplitude-loading-screen'

const InitialAmplitudeLoadingScreenCleanup = () => {
  useLayoutEffect(() => {
    const initialLoadingScreen = document.getElementById(
      INITIAL_AMPLITUDE_LOADING_SCREEN_ID
    )

    if (initialLoadingScreen) {
      initialLoadingScreen.remove()
    }
  }, [])

  return null
}

const LazyIntercom = () => {
  useEffect(() => {
    const loadIntercom = () => {
      if (window.Intercom) return
      const script = document.createElement('script')
      script.src = 'https://widget.intercom.io/widget/mnsq6i6j'
      script.async = true
      document.body.appendChild(script)
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadIntercom, { timeout: 2000 })
    } else {
      setTimeout(loadIntercom, 2000)
    }
  }, [])
  return null
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.hash) {
    return false
  }

  if (location.action === 'PUSH') {
    window.setTimeout(() => window.scrollTo(0, 0), 600)
  } else {
    const savedPosition = getSavedScrollPosition(location)
    window.setTimeout(() => window.scrollTo(...(savedPosition || [0, 0])), 600)
  }
  return false
}

const AmplitudeProviders = ({ children }) => {
  return (
    <AmplitudeProvider>
      <AmplitudeExperimentProvider>
        <AmplitudeEngagementProvider>{children}</AmplitudeEngagementProvider>
      </AmplitudeExperimentProvider>
    </AmplitudeProvider>
  )
}

export const wrapPageElement = ({ element, props }) => {
  return (
    <>
      <MediaQueryProvider {...props}>
        <LocationProvider>
          <AmplitudeProviders>
            <SanityProvider>
              <InitialAmplitudeLoadingScreenCleanup />
              <LazyIntercom />
              {element}
            </SanityProvider>
          </AmplitudeProviders>
        </LocationProvider>
      </MediaQueryProvider>
    </>
  )
}
